module.exports = __webpack_public_path__ + "static/img/H38.4279774.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H38.png
// module id = L0/o
// module chunks = 0